import {
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Input,
  Modal,
  Form,
  Spin,
  notification,
  Button,
  Switch,
} from "antd";
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";

import { useAuth } from "../../context/auth";

const ActionModal = ({
  visible,
  modalType,
  editRecord,
  onCancel,
  onOk,
}) => {
  const { accessToken } = useAuth();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      if (modalType === 'new')
        form.resetFields();
      else
        form.setFieldsValue(editRecord);
    }
  }, [form, visible, modalType, editRecord]);

  return (
    <>
      <Modal
        open={visible}
        title={
          modalType === "new" ? (
            <div className="flex items-center">
              <PlusOutlined />
              <span className="ml-2">New Mobile User</span>
            </div>
          ) : (
            <div className="flex items-center space-x-4">
              <EditOutlined />
              <span>Edit Mobile User</span>
            </div>
          )
        }
        width={window.innerWidth <= 1000 ? "95%" : "65%"}
        onCancel={onCancel}
        footer={
          <div className="w-full text-center mb-4 flex justify-center">
            <Button
              className="w-36"
              type="primary"
              ghost
              key="cancel"
              shape="round"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              onClick={() => form.submit()}
              className="w-36"
              key="save"
              type="primary"
              shape="round"
              loading={loading}
            >
              Save
            </Button>
          </div>
        }
      >
        <Spin spinning={loading} tip="Loading...">
          <Form
            form={form}
            onFinish={async (values) => {
              setLoading(true);

              const url = new URL(modalType === 'new' ? '/api/user' : '/api/user/' + editRecord.id, window.location);

              const res = await fetch(url, {
                method: modalType === 'new' ? 'POST' : 'PATCH',
                headers: {
                  'X-ACCESS-TOKEN': accessToken,
                  'content-type': 'application/json',
                },
                body: JSON.stringify({
                  ...values,
                  type: 'mobile',
                }),
              });
              if (res.ok) {
                notification["success"]({
                  message: "Successfully saved data.",
                });
                onOk();
              } else {
                // A 500 can carry a non-JSON body, and letting that throw here
                // would leave the modal stuck on its spinner.
                const code = await res.json().then(data => data.message).catch(() => res.status);

                if (res.status === 409 && (code === 'tel' || code === 'email')) {
                  notification["error"]({
                    message: code === 'tel'
                      ? "This phone number is already registered."
                      : "This email is already registered.",
                    description: "Please use a different one.",
                  });
                } else {
                  notification["error"]({
                    message: "Something went wrong !",
                    description: `Please re-login or contact web admin. (Code: ${code})`,
                  });
                }
              }

              setLoading(false);
            }}
            className="add_modal"
            layout="vertical"
          >
            <Row>
              <Col lg="6">
                <Form.Item
                  label="Name"
                  name="firstName"
                  colon={false}
                  initialValue=""
                >
                  <Input
                    placeholder="Name"
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col lg="6">
                <Form.Item
                  label="Surname"
                  name="lastName"
                  colon={false}
                  initialValue=""
                >
                  <Input
                    placeholder="Surname"
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <Form.Item
                  label="Email"
                  name="email"
                  colon={false}
                  initialValue=""
                  rules={[
                    {
                      required: true,
                      message: "Email is required.",
                    },
                    {
                      pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Email isn't correct.",
                    },
                    {
                      whitespace: true,
                      message: "Email is not whitespace",
                    },
                  ]}
                >
                  <Input
                    placeholder="Email"
                  />
                </Form.Item>
              </Col>
              <Col lg="6">
                <Form.Item
                  label="Phone Number"
                  name="tel"
                  colon={false}
                  initialValue=""
                  rules={[
                    {
                      // Catches a mistyped number before it reaches the
                      // duplicate check, which compares digits only.
                      pattern: /^[0-9+\-() ]{9,20}$/,
                      message: "Invalid phone number.",
                    },
                  ]}
                >
                  <Input
                    placeholder="Phone Number"
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <Form.Item
                  label="Active"
                  name="active"
                  colon={false}
                  initialValue={false}
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Modal >
    </>
  );
};

export default ActionModal;
